import React, { useState } from 'react';
function IdealWeight({ result}) {
  return (
    <table >
      <thead>
        <tr>
          <th >Rumus/Formula</th>
          <th > Berat Badan Ideal</th>
         </tr>
      </thead>
      <tbody>
        <tr >
          <td>Hamwi (1964)	</td>
           <td>{result.hamwi} kg</td>
         </tr>
        <tr >
           <td>Devine (1974)	 </td>
           <td>{result.devine} kg  </td>
         </tr>
        <tr >
           <td>Robinson (1983)</td>
           <td>{result.robinson} kg</td>
         </tr>
        <tr >
         <td>
        Miller (1983)
           </td>
           <td>{result.miller} kg</td>
         </tr>
        <tr >
           <td>Indeks Massa Tubuh (BMI) Sehat</td>
           <td>{result.bmiRange.lower} - {result.bmiRange.upper} kg </td>
         </tr>
      </tbody>
     </table>
  );
}
export default IdealWeight;